var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('ImageText',{staticClass:"additional-sections",attrs:{"value":_vm.value,"theme":"sections"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }